import { Typography } from "@mui/material";

export const FooterCopyright = () => {
	const currentYear = new Date().getFullYear();

	return (
		<Typography
			variant="caption"
			sx={{ color: "white", lineHeight: 4, paddingLeft: "16px" }}
		>
			{`© Scopely, Inc. ${currentYear}. All Rights Reserved.`}
		</Typography>
	);
};
